/**
 * Constantes y helpers compartidos para el módulo de ausencias.
 */

export const ABSENCE_TYPES = [
  { value: "vacation", label: "Vacaciones", tone: "brand" },
  { value: "personal", label: "Asunto propio", tone: "info" },
  { value: "sick", label: "Baja médica", tone: "warning" },
  { value: "parental", label: "Maternidad / paternidad", tone: "success" },
  { value: "other", label: "Otro", tone: "neutral" },
];

export const ABSENCE_TYPE_LABEL = ABSENCE_TYPES.reduce((acc, t) => {
  acc[t.value] = t.label;
  return acc;
}, {});

export const ABSENCE_TYPE_TONE = ABSENCE_TYPES.reduce((acc, t) => {
  acc[t.value] = t.tone;
  return acc;
}, {});

export const ABSENCE_STATUSES = [
  { value: "pending", label: "Pendiente", tone: "pending" },
  { value: "approved", label: "Aprobada", tone: "success" },
  { value: "rejected", label: "Rechazada", tone: "danger" },
  { value: "cancelled", label: "Cancelada", tone: "neutral" },
];

export const ABSENCE_STATUS_LABEL = ABSENCE_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const ABSENCE_STATUS_TONE = ABSENCE_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.tone;
  return acc;
}, {});

const MONTHS_ES = [
  "ene", "feb", "mar", "abr", "may", "jun",
  "jul", "ago", "sep", "oct", "nov", "dic",
];

export function formatRange(startYmd, endYmd) {
  if (!startYmd) return "—";
  const fmt = (ymd) => {
    const [y, m, d] = ymd.split("-").map(Number);
    if (!y || !m || !d) return ymd;
    return `${d} ${MONTHS_ES[m - 1]} ${y}`;
  };
  if (!endYmd || endYmd === startYmd) return fmt(startYmd);
  return `${fmt(startYmd)} → ${fmt(endYmd)}`;
}

export function formatDays(daysRaw) {
  const n = Number(daysRaw);
  if (!Number.isFinite(n)) return "—";
  return Number.isInteger(n) ? `${n}d` : `${n}d`;
}
